import React from "react";

const Focus = () => {
  return (
    <div>
      <h2 className="mt-35" style={{ backgroundColor: "#ff9100" }}>
        MISSION STATEMENT
      </h2>
      <div className="row justify-content-center section-title mt-25">
        <div className="col-md ">
          <p>
            <large>
              <em>
                <strong>
                  {" "}
                  To accelerate digital innovation and transformation by
                  creating software that suits diverse needs of end users.
                </strong>
              </em>
            </large>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Focus;
